import { render, staticRenderFns } from "./PromoCodePageTemplate.vue?vue&type=template&id=3b23443c&scoped=true&"
import script from "./PromoCodePageTemplate.vue?vue&type=script&lang=js&"
export * from "./PromoCodePageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodePageTemplate.vue?vue&type=style&index=0&id=3b23443c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b23443c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAvatar,VBtn})
